import React from "react";

function BS4_Utilities() {
  return (
    <div>
      <h1>BS4_Utilities Component</h1>
      <p>This is the BS4_Utilities tutorial page content.</p>
    </div>
  );
}

export default BS4_Utilities;
